/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

const DataTransferStep = ({ name, index }: { name: string; index: number }) => {
  return (
    <div
      css={css`
        width: 100%;
        display: flex;
        align-items: center;
      `}
    >
      <div
        css={css`
          width: 100px;
          background: #1c6ecd;
          text-align: center;
          color: #e6eef8;
          position: relative;
          font-weight: bold;
          padding: 4px;
          cursor: default;

          &::before {
            content: '';
            position: absolute;
            top: 5px;
            right: -11px;
            background: #1c6ecd;
            border: none;
            width: 23px;
            height: 21px;
            transform: rotate(45deg);
            z-index: 10;
          }
        `}
      >
        step{index}
      </div>

      <div
        css={css`
          flex: 1;
          padding: 4px 4px 4px 24px;
          background-color: #e6eef8;
          color: #1c6ecd;
          cursor: default;
        `}
      >
        {name}
      </div>
    </div>
  );
};

export default DataTransferStep;
